<template>
  <p>
    <span>{{ label }}</span>
  </p>
</template>

<script>
export default {
  name: 'LineLabel',
  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  p {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #000;
    line-height: 0.1em;
    margin: 10px 0 20px;
  }

  p span {
    background:$page-background-color;
    padding:0 10px;
  }
</style>
